class AutogrowDirective {
    constructor($compile, $timeout) {
        this.restrict = 'A';
        this.$compile = $compile;
        this.$timeout = $timeout;
    }

    link(scope, element) {
        element.css({'height': 'auto', 'overflow-y': 'hidden'});
        this.$timeout(function () {
            element.css('height', element[0].scrollHeight + 'px');
        }, 100);

        element.on('input', function () {
            element.css({'height': 'auto', 'overflow-y': 'hidden'});
            element.css('height', element[0].scrollHeight + 'px');
        });
    }

    static directiveFactory($compile, $timeout) {
        'ngInject';
        return new AutogrowDirective($compile, $timeout);
    }
}

export default AutogrowDirective;
